import { FC } from 'react';
import ContentLoader from 'react-content-loader';

const BalanceSkeleton: FC = () => {
  return (
    <ContentLoader
      speed={1}
      width={150}
      height={70}
      viewBox="0 0 150 80"
      backgroundColor="#f3f3f3"
      foregroundColor="#d9d9d9"
    >
      <rect x="45" y="0" rx="3" ry="3" width="60" height="20" />
      <rect x="25" y="30" rx="4" ry="4" width="100" height="32" />
      <rect x="35" y="70" rx="3" ry="3" width="80" height="20" />
    </ContentLoader>
  );
};

export default BalanceSkeleton;
